import { useNavigate, useParams } from 'react-router-dom';
import { MyParams, RouteEnum, generateRoutePath } from 'App/routes';
import { NestedRouteComponent, NestedRoutes, usePartner } from '@shared';
import { List, Create, Edit, ManageUsers } from './components';
import { AddUsers } from './components/addUsers';

export const Courses = () => {
  const { partner } = useParams<keyof MyParams>() as MyParams;
  const { enableSelfService } = usePartner({ partner });
  const navigate = useNavigate();

  const rootPath = generateRoutePath({
    name: RouteEnum.Courses,
    params: { partner },
  });

  const onExit = () => navigate(rootPath);

  const ListComponent = (
    <List rootPath={rootPath} partner={partner} enableSelfService={enableSelfService} />
  );
  const CreateComponent = <Create rootPath={rootPath} partnerId={partner} />;
  const EditComponent = <Edit rootPath={rootPath} partnerId={partner} />;
  const ManageUsersComponent = <ManageUsers rootPath={rootPath} partnerId={partner} />;
  const AddUsersComponent = <AddUsers partnerId={partner} onExit={onExit} />;

  return (
    <>
      <NestedRouteComponent
        canEdit={enableSelfService}
        canCreate={enableSelfService}
        rootPath={rootPath}
        List={ListComponent}
        Create={CreateComponent}
        Edit={EditComponent}
        extraRoutes={[
          { path: NestedRoutes.ManageUsers, element: ManageUsersComponent, available: true },
          { path: NestedRoutes.AddUsers, element: AddUsersComponent, available: enableSelfService },
        ]}
      />
    </>
  );
};
